import React from 'react'
import PageTitle from '../components/PageTitle'
import Layout from '../components/Layout'

const Mission = () => (
  <Layout>
    <PageTitle name="Mission" site="OIRA" />
    <h2 id="goal-to-be-a-trusted-provider-of-timely-relevant-and-unbiased-information-and-services-">
      Goal: To be a trusted provider of timely, relevant, and unbiased
      information and services.
    </h2>
    <p>
      The mission of the Office of Institutional Research and Assessment is to
      provide institutional information to external reporting groups as well as
      University decision-makers in support of planning, policy formulation,
      resource allocation, and the advancement of University operations. This is
      accomplished by managing and stewarding official University data, conducting data analysis, performing assessment research,
      and creating both static and dynamic visualization reports.
    </p>
    <h2 id="core-functions">Core Functions</h2>
    <p>
      Mandated regulatory reporting to external groups [National Center for
      Education Statistics (NCES), Alabama Commission on Higher Education
      (ACHE), Southern Association for Colleges and Schools (SACS), and
      University of Alabama System (UAS), as well as media and
      ranking agencies that have bearing on the University image and
      reputation]. Decision-support information for University units&#39;
      (leadership administration, colleges or schools, departments, programs, or
      committees) administrative and operational support. Responsible for creating, managing, and stewardship of official University data and information. Assessment-related
      research to evaluate and illuminate issues associated with the University
      units&#39; operations and functions. Create and distribute static and dynamic information visualization reports to advance
      the University units&#39; operations and enhance the information flow
      within the University.
    </p>
    <p>
      This office has access to a great deal of confidential data regarding the
      campus, personnel, and students. It is critical for the office to maintain
      the trust of the campus in its handling of these data. Therefore, this
      office adheres to the accepted “<a href="https://www.airweb.org/ir-data-professional-overview/statement-of-ethical-principles/principles">Code of Ethics</a>” for our profession
      .
    </p>
    <h2 id="definitions-of-institutional-research">
      Definitions of Institutional Research
    </h2>
    <blockquote>
      <p>
        “Institutional research has to do with what decisions makers need to
        know about an institution, its educational objectives, goals and
        purposes, environmental factors, process, and structures to more wisely
        use its resources, more successfully attain its objectives and goals,
        and to demonstrate integrity and accountability in so doing.”
      </p>
    </blockquote>
    <p>
      Dressel, P. L. The shaping of institutional research and planning.
      Research in Higher Education, 51 (2).
    </p>
    <blockquote>
      <p>
        “Institutional research is research conducted within an institution of
        higher education in order to provide information which supports
        institutional planning, policy formulation and decision making.”
      </p>
    </blockquote>
    <p>
      Saupe, Joe L. The Functions of Institutional Research. Tallahassee, FL:
      Association for Institutional Research, 1981.
    </p>
  </Layout>
)

export default Mission
